import { useQuery } from 'react-query'
import commandBusAPI from '../service/commandBusAPI'

export const useMomiStatus = (momiId?: string) => {
  const query = useQuery({
    queryKey: ['command-bus', 'momi-status', momiId],
    queryFn: () => commandBusAPI.getMomiStatus(momiId as string),
    enabled: Boolean(momiId),
    // Poll toutes les 10s — cadence raisonnable pour le badge en-tête,
    // alignée avec la fréquence attendue de mise à jour des heartbeats WS.
    refetchInterval: 10_000,
    refetchOnWindowFocus: true,
    staleTime: 5_000,
  })

  return query
}

export default useMomiStatus
